import React from 'react';
import { HiEye, HiEyeOff } from 'react-icons/hi';

const InputField = ({
  id,
  name,
  type,
  placeholder,
  value,
  onChange,
  error,
  showPasswordToggle,
  onToggleShowPassword,
  label,
  countryCodeSelect,
  countries,
  onCountryCodeChange,
  countryCode,
  disabled,
  className = '', // Add className prop with default value
}) => {
  return (
    <div className={className}>
      <label className="block text-sm font-medium text-black">{label}</label>
      <div className="relative flex items-center">
        {/* Country Code Dropdown */}
        {countryCodeSelect && (
          <select
            name="countryCode"
            value={countryCode}
            onChange={onCountryCodeChange}
            className="block w-1/4 border border-gray-300 rounded-md py-2 px-3 text-gray-900 text-xs"
          >
            {countries.map((country) => (
              <option key={country.code} value={country.code}>
                {country.code} | {country.phoneFormat}
              </option>
            ))}
          </select>
        )}

        {/* Mobile Number Input */}
        <input
          id={id}
          name={name}
          type={type}
          placeholder={placeholder}
          value={value}
          onChange={onChange}
          disabled={disabled} // Apply the disabled prop
          className="block w-full border border-gray-300 hover:border-black rounded-md py-2 px-3 text-gray-900 placeholder:text-gray-400 text-xs"
        />

        {showPasswordToggle &&
          !disabled && ( // Disable toggle if input is disabled
            <button
              type="button"
              onClick={onToggleShowPassword}
              className="absolute inset-y-0 right-0 flex items-center px-2"
            >
              {type === 'password' ? <HiEyeOff /> : <HiEye />}
            </button>
          )}
      </div>
      {error && <span className="text-red-800 pl-1 text-xs">{error}</span>}
    </div>
  );
};

export default InputField;
